import { Tank } from 'src/types/ViewModel/Vessel/Tank';
import { TankPlan } from 'src/types/ViewModel/Vessel/TankPlan';

export const getAllTanks = (tankPlan: TankPlan): Tank[] => {
    // TODO: NULL-SAFETY - Missing null/undefined check for tankPlan parameter. Should validate tankPlan exists before accessing properties.
    return tankPlan.tankColumns.flatMap((t) => t.tankRows.flatMap((tr) => tr.tanks)).concat(tankPlan.deckTanks.map((d) => d.tank));
};

export const getTank = (tankPlan: TankPlan, tankId: number): Tank | null => {
    // TODO: NULL-SAFETY - Missing null/undefined check for tankPlan parameter. Should validate tankPlan exists before calling getAllTanks.
    return getAllTanks(tankPlan).find((t) => t.tankId === tankId) ?? null;
};
